import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import {ActionTypes} from '../constants/CentricConstants';
import {ReduceStore} from 'flux/utils';

class UsernameStore extends ReduceStore {
    getInitialState() {
        return {
            isFetching: 0,
            usernames: []
        };
    }

    isFetching() {
        return this.getState().isFetching > 0;
    }

    getByUsername(username) {
        return this.getState().usernames[username] || null;
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.USER_USERNAME_VALIDATE_REQUEST:
                return {...state, isFetching: state.isFetching + 1 };

            case ActionTypes.USER_USERNAME_VALIDATE_SUCCESS:
                return {
                    ...state,
                    usernames: {
                        ...state.usernames,
                        [action.payload.username]: action.data
                    },
                    isFetching: state.isFetching - 1
                };

            case ActionTypes.USER_USERNAME_VALIDATE_FAILURE:
                return {...state, isFetching: state.isFetching - 1 };

            default:
                return state;
        }
    }
}

export default new UsernameStore(CentricDispatcher);
